// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import Avatar from "../../Assets/Images/Home_Image2.png";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faBox,
//   faCalendarDays,
//   faUsers,
//   faTable,
// } from "@fortawesome/free-solid-svg-icons";

// const Dashboard = () => {
//   const [courseCount, setCourseCount] = useState(0);
//   const [eventCount, setEventCount] = useState(0);
//   const [inquiriesCount, setInquiriesCount] = useState(0);
//   const [applicationCount, setApplicationCount] = useState(0);

//   const getCount = (data) => {
//     if (Array.isArray(data)) {
//       return data.length;
//     }
//     if (data && Array.isArray(data.data)) {
//       return data.data.length;
//     }
//     return 0;
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const [coursesRes, eventsRes, inquiriesRes, applicationsRes] =
//           await Promise.all([
//             axios.get(`${process.env.REACT_APP_API_URL}/courses/get-all`),
//             axios.get(`${process.env.REACT_APP_API_URL}/events/get-all`),
//             axios.get(`${process.env.REACT_APP_API_URL}/contact/get-all`),
//             axios.get(
//               `${process.env.REACT_APP_API_URL}/application/get-all-applications`
//             ),
//           ]);

//         setCourseCount(getCount(coursesRes.data));
//         setEventCount(getCount(eventsRes.data));
//         setInquiriesCount(getCount(inquiriesRes.data));
//         setApplicationCount(getCount(applicationsRes.data));
//       } catch (error) {
//         console.error("Error fetching dashboard data:", error);
//       }
//     };

//     fetchData();
//   }, []);

//   const dashboardData = [
//     {
//       icon: <FontAwesomeIcon icon={faTable} />,
//       heading: "Total Courses",
//       numbers: courseCount,
//     },
//     {
//       icon: <FontAwesomeIcon icon={faCalendarDays} />,
//       heading: "Total Events",
//       numbers: eventCount,
//     },
//     {
//       icon: <FontAwesomeIcon icon={faBox} />,
//       heading: "Total Inquiries",
//       numbers: inquiriesCount,
//     },
//     {
//       icon: <FontAwesomeIcon icon={faUsers} />,
//       heading: "Total Applications",
//       numbers: applicationCount,
//     },
//   ];

//   return (
//     <>
//       <section className="mx-5 mt-4">
//         <div className="mt-20 bg-gradient-to-r from-primaryColor to-secondaryColor flex flex-col lg:flex-row justify-center items-center gap-8 lg:gap-12 py-16 rounded-xl text-white">
//           <span>
//             <img
//               src={Avatar}
//               alt="Admin Avatar"
//               className="w-28 h-28 rounded-full border-4 border-white"
//             />
//           </span>
//           <div className="text-center space-y-2 lg:space-y-4">
//             <h1 className="text-2xl xl:text-5xl font-bold">
//               Welcome Back, Admin! 👋
//             </h1>
//             <p className="text-lg xl:text-2xl tracking-wider leading-8">
//               Here's a quick snapshot of your institute's performance today. 🚀
//             </p>
//           </div>
//         </div>

//         {/* Dashboard Cards */}
//         <div className="mt-8 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 cursor-pointer">
//           {dashboardData.map((data, idx) => (
//             <div
//               key={idx}
//               className="px-8 py-6 rounded-lg shadow-md flex justify-start items-center gap-6 bg-gradient-to-r from-primaryColor to-secondaryColor text-white"
//             >
//               <span>
//                 <i className="bg-gray-600 p-3 rounded-full">{data.icon}</i>
//               </span>
//               <span>
//                 <h1 className="text-lg font-semibold">{data.heading}</h1>
//                 <h2 className="text-lg font-bold">
//                   {data.numbers ?? "Loading..."}
//                 </h2>
//               </span>
//             </div>
//           ))}
//         </div>
//       </section>
//     </>
//   );
// };

// export default Dashboard;

import React, { useEffect, useState } from "react";
import axios from "axios";
import Avatar from "../../Assets/Images/user.gif";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBox,
  faCalendarDays,
  faUsers,
  faTable,
} from "@fortawesome/free-solid-svg-icons";
import video from "../../Assets/Images/Video.mp4";
import bgcolor from "../../Assets/Images/dashboardbg.jpg";
// import bgcolor from "../../Assets/Images/dashboardbg.jpg";

const Dashboard = () => {
  const [courseCount, setCourseCount] = useState(0);
  const [eventCount, setEventCount] = useState(0);
  const [inquiriesCount, setInquiriesCount] = useState(0);
  const [applicationCount, setApplicationCount] = useState(0);

  const getCount = (data) => {
    if (Array.isArray(data)) {
      return data.length;
    }
    if (data && Array.isArray(data.data)) {
      return data.data.length;
    }
    return 0;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [coursesRes, eventsRes, inquiriesRes, applicationsRes] =
          await Promise.all([
            axios.get(`${process.env.REACT_APP_API_URL}/courses/get-all`),
            axios.get(`${process.env.REACT_APP_API_URL}/events/get-all`),
            axios.get(`${process.env.REACT_APP_API_URL}/contact/get-all`),
            axios.get(
              `${process.env.REACT_APP_API_URL}/application/get-all-applications`
            ),
          ]);

        setCourseCount(getCount(coursesRes.data));
        setEventCount(getCount(eventsRes.data));
        setInquiriesCount(getCount(inquiriesRes.data));
        setApplicationCount(getCount(applicationsRes.data));
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    };

    fetchData();
  }, []);

  const dashboardData = [
    {
      icon: <FontAwesomeIcon icon={faTable} />,
      heading: "Total Courses",
      numbers: courseCount,
    },
    {
      icon: <FontAwesomeIcon icon={faCalendarDays} />,
      heading: "Total Events",
      numbers: eventCount,
    },
    {
      icon: <FontAwesomeIcon icon={faBox} />,
      heading: "Total Inquiries",
      numbers: inquiriesCount,
    },
    {
      icon: <FontAwesomeIcon icon={faUsers} />,
      heading: "Total Applications",
      numbers: applicationCount,
    },
  ];

  return (
    <>
      <section className="mx-5">
        {/* Welcome Banner */}
        {/* <div className="mt-14 bg-gradient-to-r from-primaryColor to-secondaryColor flex flex-col lg:flex-row justify-center items-center gap-8 lg:gap-12 py-16 rounded-xl text-white relative overflow-hidden"> */}
        <div
          className="mt-14 flex flex-col lg:flex-row justify-center items-center gap-8 lg:gap-12 py-16 rounded-xl text-white relative overflow-hidden"
          style={{
            backgroundImage: `url(${bgcolor})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="absolute inset-0 opacity-10">
            <div className="absolute w-96 h-96 bg-white rounded-full -top-48 -right-48"></div>
            <div className="absolute w-72 h-72 bg-white rounded-full -bottom-36 -left-36"></div>
          </div>
          <span className="relative z-10">
            <img
              src={Avatar}
              alt="Admin Avatar"
              className="w-28 h-28 rounded-full border-4 border-white shadow-lg object-cover"
            />
          </span>
          <div className="text-center space-y-2 lg:space-y-4 relative z-10">
            <h1 className="text-2xl xl:text-5xl font-bold">
              Welcome Back, Admin! 👋
            </h1>
            <p className="text-lg xl:text-2xl tracking-wide leading-8 opacity-90">
              Here's a quick snapshot of your institute's performance. 🚀
            </p>
          </div>
        </div>

        {/* Dashboard Cards */}
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 cursor-pointer">
          {dashboardData.map((data, idx) => (
            <div
              key={idx}
              className="group px-8 py-6 rounded-lg shadow-md flex justify-start items-center gap-6 bg-gradient-to-r from-primaryColor to-secondaryColor text-white hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1"
            >
              <span className="bg-red-100 p-3 rounded-full group-hover:scale-110 transition-transform duration-300 text-secondaryColor">
                <i>{data.icon}</i>
              </span>
              <span>
                <h1 className="text-lg font-semibold opacity-90">
                  {data.heading}
                </h1>
                <h2 className="text-2xl font-bold">
                  {data.numbers ?? "Loading..."}
                </h2>
              </span>
            </div>
          ))}
        </div>

        {/* Video Section */}
        <div className="mt-12 mb-8">
          <div className="relative">
            {/* Decorative elements */}
            <div className="absolute -top-6 left-0 right-0 flex justify-between opacity-5 pointer-events-none">
              <div className="w-32 h-32 bg-gradient-to-r from-primaryColor to-secondaryColor rounded-full blur-3xl"></div>
              <div className="w-32 h-32 bg-gradient-to-r from-secondaryColor to-primaryColor rounded-full blur-3xl"></div>
            </div>

            {/* Video Container */}
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-r from-primaryColor to-secondaryColor rounded-2xl blur-xl opacity-0 group-hover:opacity-20 transition-all duration-300"></div>

              <div className="relative w-full rounded-2xl shadow-2xl overflow-hidden bg-black">
                {/* Video with gradient border effect */}
                <div className="p-1 rounded-2xl bg-gradient-to-r from-primaryColor via-gray-400 to-secondaryColor">
                  <video
                    width="100%"
                    height="auto"
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="w-full rounded-xl bg-black block"
                    
                    style={{ aspectRatio: "16/9" }}
                  >
                    <source src={video} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Dashboard;
